import axios from "axios";
import { Header, ServerAddress, Traveller } from "../Enum/Urls";


export const getTravellers = async () => {
    let token=localStorage.getItem("userToken");
    try {
      let response = await axios.get(`${ServerAddress.Type}${ServerAddress.Traveller}${Traveller.GetAll}`,
       {headers: {Authorization:`Bearer ${token}`,...Header}}
       );
      return response;
    } catch (error) {
      return error.response?.data || "Internal Error,Please try again";
    }
};

// export const addTravelllller = () => {

//       //handle header
//       let token = localStorage.getItem("userToken");
//       let HeaderAthu = null;
//       if (token) {
//         HeaderAthu = { Authorization: `Bearer ${token}`, ...Header };
//       } else {
//         HeaderAthu = { ...Header };
//       }

//     const params = { 
//     "tenantId": 6,
//     "userId": 20139, 
//     "firstname": "jovani", 
//     "firstnamePersian": "", 
//     "lastname": "petsi", 
//     "lastnamePersian": "", 
//     "gender": true, 
//     "nationalId": "", 
//     "birthDate": "1985-01-10",
//      "nationality": "IT",
//       "email": "petsi@testi.com",
//        "passportCountry": "NO",
//         "passportExpirationDate": "2027-11-27",
//          "passportNumber": "123710",
//           "phoneNumber": "string",
//            "id": 0 }

//       axios({
//         method: "post",
//         url: `https://traveller.itours.ir/api/services/app/Passenger/Create`,
//         data: { ...params },
//         headers: HeaderAthu,
//       })
//         .then((responsive) => {
//             debugger;
//         })
//         .catch((error) => {
//         });
 
//   };